import * as React from "react";
import InfiniteScroll from "react-infinite-scroller";
import "./SpsNotificationDropdown.scss";
import { SpsNotificationRow } from "../SpsNotificationRow";

function truncateNumber(number) {
  const num = parseFloat(number);
  if (num > 99) {
    return "99 +";
  }
  // for consistency sake, we will always return a string representation of a number
  return num.toString();
}



export default function SpsNotificationDropdown(props) {
  const buttonRef = React.useRef(null);
  const [listVisible, setListVisibility] = React.useState(false);
  const [eventCollection, setEventCollection] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [nextPage, setNextPage] = React.useState(2);
  const [hasMore, setHasMore] = React.useState(true);
  const { notifications, readMessages, unreadMessages, error, eventClickFn, fetchEventFn, dropdownCloseFn, markAllReadFn, ...rest } = props;
  React.useEffect(() => {
    setEventCollection(notifications);
  }, [notifications]);
  React.useEffect(() => {
    if (!listVisible && typeof dropdownCloseFn === 'function') {
      dropdownCloseFn();
    }
  }, [listVisible]);
  const openRxDropdown: Event = new CustomEvent("openRxDropdown");

  const handleOnChange = e => {
    e.preventDefault();
    e.stopPropagation();
    // this is needed to orchestrate dropdowns between ng and rx sides of the app
    dispatchEvent(openRxDropdown);
    readMessages();
    toggleDropdown();
  };
  const toggleDropdown = () => {
    setListVisibility(currVisibility => {
      return !currVisibility;
    });
  };
  const openDropdown = () => {
    setListVisibility(true);
  };
  const closeDropdown = () => {
    setListVisibility(false);
  };
  window.addEventListener("clickOut", e => {
    closeDropdown();
  });
  // this is needed to orchestrate dropdowns between ng and rx sides of the app
  window.addEventListener("openNgDropdown", e => {
    closeDropdown();
  });
  const loadEvents = () => {
    if (!loading) {
      setLoading(true);
      fetchEventFn(nextPage)
        .then(response => {
          setHasMore(!!response?.data?.next);
          setEventCollection(eventCollection.concat(response?.data?.results || []));
          setNextPage(nextPage + 1);
        }) // error state set by parent component
        .finally(() => {
          setLoading(false);
        });

    }
  }
  return (
    <div className="sps-notification-dropdown" data-testid="notification-dropdown">
      <a
        data-testid="notification-dropdown-trigger"
        href="#"
        className="sps-notification-dropdown-link"
        onClick={handleOnChange}
        ref={buttonRef}
        title="Notifications"
      >
        <div className="sps-notification-dropdown-wrapper clearfix">
          <i className="fa fa-bell" />
          {unreadMessages > 0 && (
            <span className="sps-notification-dropdown__unread-message-counter">
              {truncateNumber(unreadMessages)}
            </span>
          )}
        </div>
      </a>
      {listVisible && (
        // We need to stopPropagation otherwise clickOut event will be triggered when clicking on the dropdown
        <div
          className="sps-notification-dropdown-container"
          data-testid="notification-dropdown-wrapper"
          onClick={e => e.stopPropagation()}
        >
          {
            !error && notifications.length > 0 &&
            (
              <div className="sps-notification-dropdown-action-drawer clearfix">
                <span className="sps-notification-dropdown__mark-all-as-read-link" onClick={markAllReadFn}>Mark All as Read</span>
              </div>
            )
          }
          {!error ? (
            <div className="sps-notification-dropdown-list">
              {eventCollection.length > 0 ? (
                <InfiniteScroll
                  pageStart={1}
                  loadMore={loadEvents}
                  initialLoad={false}
                  hasMore={hasMore}
                  loader={<div className="loader" key={eventCollection.length + 1} >Loading ...</div>}
                  threshold={50}
                  useWindow={false}>
                  {eventCollection.map(item => {
                    return <SpsNotificationRow key={item.id} event={item} eventClickHandler={eventClickFn} />;
                  })}
                </InfiniteScroll>
              ) : (
                  <div className="sps-zero-state sps-zero-state--micro">
                    <i className="sps-icon sps-icon-file" />
                    <h1 className="sps-zero-state__heading">No Notifications</h1>
                    <h2 className="sps-zero-state__subheading">
                      You haven’t received any notifications yet.
              </h2>
                  </div>
                )}
            </div>
          ) : (
              <div className="sps-zero-state sps-zero-state--micro">
                <i className="sps-icon sps-icon-exclamation-triangle sps-notification-dropdown__error-icon" />
                <h1 className="sps-zero-state__heading">Uh oh</h1>
                <h2 className="sps-zero-state__subheading">
                  We’re having problems finding your notifications.
          </h2>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
